import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { API_URL } from "../config";
import logoVNF from "../assets/img/logo-vnf-monochrome.svg";
import logoHaropa from "../assets/img/logo-haropa.svg";
import logoCofinanceEU from "../assets/img/Cofinance-par-l-Union-europeenne.png";
import logoRIDF from "../assets/img/LOGO_RIDF_2019_COMPACT.svg";

const LanguageSelector = ({ navigation, navbar }) => {
    const [open, setOpen] = useState(false);
    // used to disable tab navigation in hidden menu after animation
    const [disableMenu, setDisableMenu] = useState(true);
    const { i18n, t } = useTranslation();

    const language = i18n.options.resources[i18n.language].name;
    const languageKey = i18n.options.resources[i18n.language].key;
    const languages = Object.values(i18n.options.resources);

    const classNameSuffix = navbar
        ? "--navbar"
        : navigation
          ? "--navigation"
          : "";

    const handleClick = async (e) => {
        const lang = e.target.value;
        // save localStorage language to keep language after refresh
        localStorage.setItem("language", lang);
        i18n.changeLanguage(lang);
        setOpen(false);

        if (navigation) sendLanguageChangeRequest(lang);
    };

    const closeMenu = () => {
        setOpen(false);
    };

    const sendLanguageChangeRequest = async (lang) => {
        try {
            const response = await fetch(API_URL + "/user/csrf", {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                credentials: "include",
            });
            const data = await response.json();
            const csrf = data.token;

            fetch(API_URL + "/user/language/" + lang, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                credentials: "include",
                body: JSON.stringify({
                    _csrf_token: csrf,
                }),
            });
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        let timer = null;
        if (open) {
            timer = setTimeout(() => setDisableMenu(false), 0);
        } else {
            timer = setTimeout(() => setDisableMenu(true), 250);
        }
        return () => clearTimeout(timer);
    }, [open]);

    return (
        <div className={`language-selector${classNameSuffix}`}>
            <button
                title={t("lang_choice")}
                className={`language-selector${classNameSuffix}__toggle`}
                onClick={() => setOpen(!open)}
            >
                {navbar ? (
                    <span
                        className={`language-selector${classNameSuffix}__lang`}
                    >
                        {languageKey}
                    </span>
                ) : (
                    language
                )}
                {!navbar && (
                    <i
                        className={`vnf-icons-icon-m-fleche-a-${open ? "haut" : "bas"}-outline`}
                    ></i>
                )}
            </button>
            <div
                className={`language-selector--menu${open ? " open" : ""}${disableMenu ? " disabled" : ""}`}
            >
                <div className="language-selector--menu__header">
                    <button
                        type="button"
                        onClick={closeMenu}
                        className="language-selector--menu__close"
                    >
                        <i className="vnf-icons-icon-s-croix-solid"></i>
                    </button>
                </div>
                <div className="language-selector--menu__separator" />
                <ul className="language-selector--menu__list">
                    {languages.map((lang) => (
                        <li key={lang.key}>
                            <button
                                type="button"
                                value={lang.key}
                                onClick={handleClick}
                                className={`language-selector--menu__lang${lang.key === languageKey ? " active" : ""}`}
                            >
                                {lang.name}
                            </button>
                        </li>
                    ))}
                </ul>
                <div className="language-selector--menu__separator" />
                <div className="language-selector--menu__footer">
                    <div>
                        <p>{t("A service developped by ...")}</p>
                        <div className="language-selector--menu__footer__logos">
                            <img src={logoVNF} alt="VNF" height="55" />
                            <img src={logoHaropa} alt="Haropa" />
                        </div>
                    </div>
                    <div>
                        <p>{t("with_support_from")}</p>
                        <div className="language-selector--menu__footer__logos">
                            <img
                                src={logoCofinanceEU}
                                height="80"
                                alt="Cofinancé par l'Union Européenne"
                            />
                            <img
                                src={logoRIDF}
                                height="80"
                                alt="Région Île de France"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div
                className={`language-selector--menu__overlay ${open ? "open" : ""}`}
                onClick={closeMenu}
            ></div>
        </div>
    );
};

export default LanguageSelector;
